import { PlusGrid, PlusGridItem, PlusGridRow } from './plusGrid'
import Button from './Button'
import Container from './Container'
import { LogoTextOnly } from './logo'
import { Link } from 'react-router-dom'
import HeroAnimation from './HeroAnimation'
import NoiseSphere from './NoiseSphere'

import { ReactComponent as HIPAALogo } from "../media/compliance/hipaa_white.svg"





const CallToAction = ({ journey }) => {
  return (
    <div className="relative py-24 sm:py-56 ">
      {/* Background animation layers (blurred, non-interactive) */}
      <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-screen pointer-events-none -z-10" aria-hidden="true">
        {/* Full-bleed blur wrapper so edges don't clip */}
        <div className="absolute inset-0 z-0" style={{ filter: 'blur(5px)' }}>
          <div
            className="absolute inset-0 flex items-center justify-center"
            style={{
              WebkitMaskImage: 'linear-gradient(to top, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 120px)',
              maskImage: 'linear-gradient(to top, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 120px)',
            }}
          >
            <div className="relative w-[min(100vw,1200px)] h-[min(100vh,800px)]">
            {/* Orb centered within the stage */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
              <div className="relative h-[200px] w-[200px] sm:h-[240px] sm:w-[240px]">
                <NoiseSphere version={0} demo_is_active={false} />
              </div>
            </div>
            {/* Animation overlay fills the stage */}
            <div className="absolute inset-0 opacity-90">
              {/* Autoplay mode (no props) to keep motion subtle behind CTA */}
              <HeroAnimation scale={1} />
              </div>
            </div>
          </div>
        </div>
        {/* Graph paper grid and edge fades (non-interactive) */}
        <div className="absolute inset-0 z-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)",
              backgroundSize: "20px 20px",
              backgroundPosition: "0 0",
            }}
          />
          {/* Edge fades on all sides to blend grid into background */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "linear-gradient(to right, rgba(12,16,28,1) 0%, rgba(12,16,28,0) 18%, rgba(12,16,28,0) 100%)",
            }}
          />
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "linear-gradient(to left, rgba(12,16,28,1) 0%, rgba(12,16,28,0) 18%, rgba(12,16,28,0) 100%)",
            }}
          />
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "linear-gradient(to bottom, rgba(12,16,28,1) 0%, rgba(12,16,28,0) 18%, rgba(12,16,28,0) 100%)",
            }}
          />
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "linear-gradient(to top, rgba(12,16,28,1) 0%, rgba(12,16,28,0) 18%, rgba(12,16,28,0) 100%)",
            }}
          />
        </div>
      </div>

      {/* CTA content */}
      <div className="relative text-center">
        <h2 className="font-display text-4xl sm:text-4xl md:text-5xl font-light tracking-tight text-white drop-shadow-lg space-y-3">
          <span className="block">Supercharge your risk adjustment operations.</span>
          <span className="block">Claim your spot in our limited pilot.</span>
        </h2>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Button to="/demo#top" variant="secondary" className="rounded-none font-normal">
            Book a demo
          </Button>
          <Link
            to="#raf-precision-ai"
            className="text-white text-base font-light rounded-none px-4 py-2 transition bg-transparent hover:bg-white/10 focus:bg-white/10 active:bg-white/20 focus:outline-none border-none cursor-pointer no-underline"
          >
            See how it works ↑
          </Link>
        </div>
      </div>
    </div>
  )
}

const SitemapHeading = ({ children }) => {
  return <h3 className="text-sm/6 font-light text-white/50">{children}</h3>
}

const SitemapLinks = ({ children }) => {
  return <ul className="mt-6 space-y-4 text-sm/6 font-light">{children}</ul>
}

const SitemapLink = (props) => {
  return (
    <li>
      <Link
        {...props}
        className="font-light text-white data-[hover]:text-white/75"
      />
    </li>
  )
}

const Sitemap = ({ set_demo_modal_is_open }) => {
  return (
    <>
      <div>
        <SitemapHeading>RAF Precision AI</SitemapHeading>
        <SitemapLinks>
          <SitemapLink to="/#raf-precision-ai">Highlights</SitemapLink>
          <SitemapLink to="/#pilot">Pilot</SitemapLink>
          <SitemapLink to="/#value-propositions">Value propositions</SitemapLink>
          <SitemapLink to="/#performance-security-safety">Performance · Security · Safety</SitemapLink>
        </SitemapLinks>
      </div>

      <div>
        <SitemapHeading>Solutions</SitemapHeading>
        <SitemapLinks>
          <SitemapLink to="/#top" >MAOs</SitemapLink>
          <SitemapLink to="/" >ACAs</SitemapLink>
          <SitemapLink to="/" >VBC Provider</SitemapLink>
        </SitemapLinks>
      </div>

      <div>
        <SitemapHeading>Links</SitemapHeading>
        <SitemapLinks>
          <SitemapLink to="demo#top">Book a demo</SitemapLink>
          <SitemapLink to="https://blog.vitalstrata.com" target="_blank" >Blog</SitemapLink>
          <SitemapLink to="https://careers.vitalstrata.com" target="_blank" >Careers</SitemapLink>
          <SitemapLink to="mailto:support@vitalstrata.com">Contact</SitemapLink>
        </SitemapLinks>
      </div>

      <div>
        <SitemapHeading>Legal</SitemapHeading>
        <SitemapLinks>
          <SitemapLink to="https://app.vitalstrata.com/terms" target="_blank" >Terms of service</SitemapLink>
          <SitemapLink to="https://app.vitalstrata.com/privacy" target="_blank" >Privacy policy</SitemapLink>
        </SitemapLinks>
      </div>
    </>
  )
}

const SocialIconX = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path d="M12.6 0h2.454l-5.36 6.778L16 16h-4.937l-3.867-5.594L2.771 16H.316l5.733-7.25L0 0h5.063l3.495 5.114L12.6 0zm-.86 14.376h1.36L4.323 1.539H2.865l8.875 12.837z" />
    </svg>
  )
}

// const SocialIconFacebook = (props) => {
//   return (
//     <svg viewBox="0 0 16 16" fill="currentColor" {...props}>
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M16 8.05C16 3.603 12.418 0 8 0S0 3.604 0 8.05c0 4.016 2.926 7.346 6.75 7.95v-5.624H4.718V8.05H6.75V6.276c0-2.017 1.194-3.131 3.022-3.131.875 0 1.79.157 1.79.157v1.98h-1.008c-.994 0-1.304.62-1.304 1.257v1.51h2.219l-.355 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.95z"
//       />
//     </svg>
//   )
// }

const SocialIconLinkedIn = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path d="M14.82 0H1.18A1.169 1.169 0 000 1.154v13.694A1.168 1.168 0 001.18 16h13.64A1.17 1.17 0 0016 14.845V1.15A1.171 1.171 0 0014.82 0zM4.744 13.64H2.369V5.996h2.375v7.644zm-1.18-8.684a1.377 1.377 0 11.52-.106 1.377 1.377 0 01-.527.103l.007.003zm10.075 8.683h-2.375V9.921c0-.885-.015-2.025-1.234-2.025-1.218 0-1.425.966-1.425 1.968v3.775H6.233V5.997H8.51v1.05h.032c.317-.601 1.09-1.235 2.246-1.235 2.405-.005 2.851 1.578 2.851 3.63v4.197z" />
    </svg>
  )
}

const SocialLinks = () => {
  return (
    <>
      {/* <Link
        to="https://www.facebook.com"
        target="_blank"
        aria-label="Visit us on Facebook"
        className="text-gray-950 data-[hover]:text-gray-950/75"
      >
        <SocialIconFacebook className="size-4" />
      </Link> */}
      <Link
        to="https://x.com/vitalstrata"
        target="_blank"
        aria-label="Visit us on X"
        className="text-white data-[hover]:text-white/75"
      >
        <SocialIconX className="size-4" />
      </Link>
      <Link
        to="https://www.linkedin.com/company/vitalstrata"
        target="_blank"
        aria-label="Visit us on LinkedIn"
        className="text-white data-[hover]:text-white/75"
      >
        <SocialIconLinkedIn className="size-4" />
      </Link>
    </>
  )
}

const Copyright = () => {
  return (
    <div className="text-sm/6 text-white/70 font-light">
      &copy; {new Date().getFullYear()} PlusIdentity Inc.
    </div>
  )
}


const Footer = ({ demo_is_active, set_demo_is_active, set_demo_modal_is_open, journey }) => {
  return (
    <div className="relative isolate overflow-hidden bg-transparent">

      {/* Content */}
      <Container>
        <CallToAction journey={journey} />
        <PlusGrid className="pb-16">





          <PlusGridRow>
            <div className="grid grid-cols-2 gap-y-10 pb-6 lg:grid-cols-6 lg:gap-8">
              <div className="col-span-2 flex">
                <PlusGridItem className="pt-6 lg:pb-6">
                  <LogoTextOnly className="h-9" fill="#fff" />
                </PlusGridItem>
              </div>
              <div className="col-span-2 grid grid-cols-2 gap-x-8 gap-y-12 lg:col-span-4 lg:grid-cols-subgrid lg:pt-6">
                <Sitemap set_demo_modal_is_open={set_demo_modal_is_open} />
              </div>
            </div>
          </PlusGridRow>







          {/* TODO - HIPAA */}
          <PlusGridRow className="flex justify-start">

            <div>
              <PlusGridItem className="h-full flex items-center py-3">
                <HIPAALogo className="w-24 h-12" />
              </PlusGridItem>
            </div>


          </PlusGridRow>









          <PlusGridRow className="flex justify-between">
            <div>
              <PlusGridItem className="h-full flex items-center py-3">
                <Copyright />
              </PlusGridItem>
            </div>
            
            <div className="flex">
              <PlusGridItem className="h-full flex items-center gap-8 py-3">
                <SocialLinks />
              </PlusGridItem>
            </div>

            {/* <div>
              <PlusGridItem className="h-full flex items-center py-3">
                <HIPAALogo className="w-24 h-12" />
              </PlusGridItem>
            </div> */}


          </PlusGridRow>




          








        </PlusGrid>
      </Container>
    </div>
  )
}



export default Footer